var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodesandbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    className: "codesandbox-svg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.5L15.5669 0L28.6384 7.5L28.7509 22.4362L15.5669 30L2.5 22.5V7.5ZM5.11188 10.6003V16.5478L9.29125 18.8719V23.2669L14.2572 26.1384V15.7969L5.11188 10.6003ZM26.035 10.6003L16.8897 15.7959V26.1375L21.8509 23.2659V18.8766L26.0359 16.5478L26.035 10.6003ZM6.41594 8.25188L15.5472 13.4325L24.6972 8.20781L19.8588 5.45906L15.5959 7.89094L11.3088 5.43L6.41594 8.25188Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodesandbox);
export default __webpack_public_path__ + "static/media/codesandbox.73e74546b9f7b3ba60a631d42893b316.svg";
export { ForwardRef as ReactComponent };